<template>
  <div v-redirect-if-no-permission:REGISTERED_CAPTAINS :key="switch1">
    <loading-component :value="loading" />
    <v-layout
      style="background-color: white; margin-bottom: -10px"
      justify-center
    >
      <v-flex xs12 sm4>
        <v-btn  v-if="this.$store.state.user.roles[0].name != 'Goverment'" color="primary" dark to="/drivers/create">{{ $t("drivers.captains.new") }}</v-btn>
      </v-flex>
      <!-- <v-flex xs12 sm4>
        <v-switch
          v-model="switch1"
          label="Autonome All"
          @change="changeAutonomeMode"
          color="blue"
        ></v-switch>
      </v-flex> -->
      <v-flex xs12 sm4>
        <v-btn  v-if="this.$store.state.user.roles[0].name == 'Super Admin'" color="primary" @click="changeAutonomeMode((switch1 = true))"
          >{{ $t("drivers.captains.activeAutonomeAll") }}</v-btn
        >
      </v-flex>
      <v-flex xs12 sm4>
        <v-btn  v-if="this.$store.state.user.roles[0].name == 'Super Admin'" color="primary" @click="changeAutonomeMode((switch1 = false))"
          >{{ $t("drivers.captains.inactiveAutonomeAll") }}</v-btn
        >
      </v-flex>
      <v-flex xs12 sm4>
        <v-select
          :items="items"
          :label="$t('drivers.captains.captainStatus')"
          v-model="status"
          @change="statusFilter"
        ></v-select>
      </v-flex>
    </v-layout>
    <DataTable
      :url="api.ACTIONS.CAPTAINS"
      :enable-edit="false"
      :enable-add="false"
      :enable-delete="false"
      :formatter="formatters"
      :initial-url-search-params="capStatus"
      :actions-extra-main="actionsExtraMain"
      :row-call-back="rowCallBack"
      perPage="100"
      :fields-hidden-main="[
        'no_conviction',
        'email',
        'updated_at',
        'whatsapp_number',
        'location_id',
        'gender',
        'driving_certificate_start_date',
        'blacklisted_at',
        'blacklist_note',
        'approved_at',
        'driving_certificate_end_date',
        'only_female',
        'finger_print',
        'car',
        'cars',
        'nationality_id',
        'bank_id',
        'profile_image',
        'delete_note',
        'wallet',
        'active',
        'deleted_at',
        'birthday',
        'id_card_front',
        'id_card_back',
        'driving_certificate_front',
        'driving_certificate_back',
        'auto_accept',
        'can_see_booking_price',
        'can_change_auto_accept',
        'only_accepts_bookings_from_suggestions',
        'end_ride',
        'address',
        'fb_token',
        'accepts_pets',
        'accepts_wheelchair',
        'payment_method',
        'taxi_number',
        'ministerial_authorization',
        'medical_certificate',
        'livret_professionnel',
        'absense_justifiee',
        'attestation_nis',
        'rib_doc',
        'electric_radio_license',
        'livret_professionnel_expiry_date',
        'electric_radio_license_expiry_date',
      ]"
      :titles="titles"
    />
    <confirm-captain-dialog
      @approved="updateUnapprovedTable"
      ref="confirm_dialog"
      :settings.sync="confirm_dialog"
    ></confirm-captain-dialog>
    <v-dialog v-model="create_interview.visible" lazy width="50%">
      <interview-creator
        :key="create_interview.visible"
        :captain="create_interview.captain"
        :enable-change-captain="false"
        :show-create-captain="false"
        :action="create_interview.action"
        :statuses="create_interview.statuses"
        @saved="interviewCreated"
      />
    </v-dialog>
    <v-dialog v-model="notesDialog.visible" width="50%">
      <v-card>
        <v-card-title primary-titly class="title font-weight-bold">
          {{ $t("drivers.captains.enterANote") }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-textarea v-model="notesDialog.note" :label="$t('drivers.captains.note')" />
        </v-card-text>
        <v-card-actions>
          <v-btn color="green" @click="notesDialog.createInterview">
            {{ $t("drivers.captains.createInterview") }}
          </v-btn>
          <v-btn color="red" @click="notesDialog.noContinue">
            {{ $t("drivers.captains.doesntWantToContinue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="enterPassword.show"
      @input="enterPassword.show = !enterPassword.show"
      width="50%"
    >
      <v-card>
        <v-card-title primary class="title red white--text font-weight-bold">
          {{ $t("drivers.captains.enterYourPassword") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4">
          <v-label class="headline">
            {{ enterPassword.hint }}
          </v-label>
          <v-form ref="password_form">
            <v-text-field
              :disabled="loading"
              type="password"
              v-model="enterPassword.password"
              :label="$t('drivers.captains.password')"
              required
            />
            <v-text-field
              v-if="enterPassword.needsNote"
              :disabled="loading"
              v-model="enterPassword.note"
              :label="$t('drivers.captains.note')"
              required
            />
          </v-form>
          <v-flex xs4 offset-xs8>
            <v-btn
              color="red"
              style="color: white"
              @click="submitPasswordAction"
            >
              {{ $t("drivers.captains.doIt") }}
            </v-btn>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";
import { toInteger } from "lodash";

export default {
  name: "RegisteredCaptains",
  title() {
    return this.$t("drivers.captains.title");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      rowCallBack(item) {
        return item.deleted_at ? ["deleted-captain"] : [];
      },
      capStatus: "",
      timer: "",
      switch1: null,
      status: "",
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
      enterPassword: {
        show: false,
        hint: null,
        password: null,
        action: null,
        needsNote: false,
        note: null,
      },
      create_interview: {
        visible: false,
        captain: null,
        statuses: [],
        action: null,
      },
      notesDialog: {
        visible: false,
        action: null,
        note: "",
        createInterview: () => {},
        noContinue: () => {},
      },
    };
  },

  watch: {
    "enterPassword.show": function (val) {
      this.enterPassword.password = null;
      this.enterPassword.note = null;
    },
  },
  computed: {
    items() {
      return [
        { text: this.$t("drivers.captains.statusAll"), value: "all" },
        { text: this.$t("drivers.captains.statusRecentlyOnline"), value: "recently-online" },
        { text: this.$t("drivers.captains.statusInStation"), value: "in-station" },
      ];
    },
    formatters() {
      const autonome = this.$t("drivers.captains.autonome");
      const normal = this.$t("drivers.captains.normal");
      return {
        autonome_mode(value) {
          return value ? autonome : normal;
        },

        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
      };
    },
    titles() {
      return {
        created_at: this.$t("drivers.captains.creationDate"),
        id: "#",
        email: this.$t("drivers.captains.email"),
        // username: "Phone Number",
        deleted_at: this.$t("drivers.captains.archivingDate"),
        active: this.$t("drivers.captains.wasApproved"),
        first_name: this.$t("drivers.captains.firstName"),
        last_name: this.$t("drivers.captains.lastName"),
        phone_number: this.$t("drivers.captains.phone"),
        status: this.$t("common.status"),
        username: this.$t("drivers.captains.taxiNumber"),
        autonome_mode: this.$t("drivers.captains.mode"),
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("drivers.captains.captainProfile"),
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              name: "CaptainProfile",
              params: { id: item.id },
            }),
        },
      };
    },
    formatter() {
      return {
        // created_at(value) {
        //   return moment(value).format(" DD MMM YYYY");
        // },

        active(val) {
          //language=HTML
          return `
                        <i class="v-icon fa ${
                          val ? "fa-check" : "fa-close"
                        }"></i>
                        `;
        },
      };
    },
    newCaqFormatter() {
      const noEntry = this.$t("drivers.captains.noCaptainEntry");
      return {
        captain_id(val) {
          return val ? val : noEntry;
        },
      };
    },
  },

  mounted() {
    this.loading = true;
    // changeAutonomeMode(value);
    this.axios
      .get(this.api.ACTIONS.INTERVIEW_STATUS)
      .then(async ({ data: { data } }) => {
        this.create_interview.statuses = data;
        this.loading = false;
      })
      .catch(() => (this.loading = false));
  },
  methods: {
    changeAutonomeMode(value) {
      const formData = new FormData();
      formData.append("status", toInteger(value));

      this.axios
        .post(`captain/changeAutonomeModeMulti`, formData)
        .then((res) => {
          console.log("success");
        })
        .catch((err) => {
          // console.log(err);
          console.log("F");
        });
    },

    // changeAutonomeMode1() {
    //   const formData = new FormData();

    //   formData.append("status", 0);
    //   this.axios
    //     .post(`captain/changeAutonomeModeMulti`, formData)
    //     .then((res) => {
    //       console.log("success");
    //     })
    //     .catch((err) => {
    //       // console.log(err);
    //       console.log("F");
    //     });
    // },
    statusFilter() {
      this.capStatus = new URLSearchParams(`status=${this.status}`);
    },
    interviewCreated() {
      window.getApp.$emit(
        "SHOW_TOAST",
        this.$t("drivers.captains.savedInterviewFor", {
          firstName: this.create_interview.captain.first_name,
          lastName: this.create_interview.captain.last_name,
        })
      );
      this.create_interview.visible = false;
    },
    async submitPasswordAction() {
      if (!this.$refs.password_form.validate()) return;
      this.loading = true;
      try {
        await this.enterPassword.action();
        this.enterPassword.show = false;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    updateUnapprovedTable(id) {
      this.$refs.unapproved.removeItemFromTable((item) => item.id !== id);
    },
    params(state) {
      return new URLSearchParams(`state=${state}`);
    },
    para(status) {
      return new URLSearchParams(`status=${status}`);
    },
    actionsExtra(state) {
      const didntAnswer = {
        title: this.$t("drivers.captains.didntAnswer"),
        color: "red",
        action: async (item) => {
          try {
            let data = {
              answered: false,
              interview: null,
              note: "Didn't Answer",
            };
            if (item.username) {
              data.captain_id = item.id;
            } else {
              data.captain_registration_request_id = item.id;
            }
            await this.axios.post(this.api.ACTIONS.INCOMPLETE_CAPTAIN, data);
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captains.saved"), "green");
            this.$set(this.notesDialog, "visible", false);
            this.create_interview.visible = false;
            this.$refs.incomplete &&
              this.$refs.incomplete.removeItemFromTable(item);
            this.$refs.new_acq && this.$refs.new_acq.removeItemFromTable(item);
          } catch (e) {
            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
          }
        },
      };

      const answered = {
        title: this.$t("drivers.captains.answered"),
        color: "green",
        action: (item) => {
          this.notesDialog = {
            visible: true,
            action: null,
            note: "",
            createInterview: async () => {
              if (!this.notesDialog.note.length) {
                alert(this.$t("drivers.captains.enterNote"));
                return;
              }
              this.notesDialog.visible = false;
              this.create_interview = {
                visible: true,
                captain: item,
                statuses: this.create_interview.statuses,
                action: async (interview) => {
                  interview.datetime = interview.date + " " + interview.time;
                  try {
                    let data = {
                      answered: true,
                      interview,
                      note: this.notesDialog.note,
                    };
                    if (item.username) {
                      data.captain_id = item.id;
                    } else {
                      data.captain_registration_request_id = item.id;
                    }
                    await this.axios.post(
                      this.api.ACTIONS.INCOMPLETE_CAPTAIN,
                      data
                    );
                    window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captains.saved"), "green");
                    this.create_interview.visible = false;
                    this.notesDialog.visible = false;
                    this.$refs.incomplete &&
                      this.$refs.incomplete.removeItemFromTable(item);
                    this.$refs.new_acq &&
                      this.$refs.new_acq.removeItemFromTable(item);
                  } catch (e) {
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      e.response.data.message,
                      "red"
                    );
                  }
                },
              };
            },
            noContinue: async () => {
              if (!this.notesDialog.note.length) {
                alert(this.$t("drivers.captains.enterNoteAlt"));
                return;
              }
              try {
                await this.axios.post(this.api.ACTIONS.INCOMPLETE_CAPTAIN, {
                  captain_id: item.id,
                  answered: true,
                  interview: null,
                  note: this.notesDialog.note,
                });
                this.notesDialog.visible = false;
                window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captains.saved"), "green");
                this.$refs.incomplete &&
                  this.$refs.incomplete.removeItemFromTable(item);
              } catch (e) {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  e.response.data.message,
                  "red"
                );
              }
            },
          };
        },
      };

      const createInterview = {
        title: this.$t("drivers.captains.createInterview"),
        color: "green",
        action: (item) => {
          this.create_interview = {
            visible: true,
            captain: item,
            statuses: this.create_interview.statuses,
          };
        },
      };

      const moveToApproved = {
        title: this.$t("drivers.captains.activate"),
        icon: "thumb_up",
        extras: {
          color: "green",
          medium: true,
        },
        action: async (item) => {
          this.confirm_dialog = {
            visible: true,
            captain_id: item.id,
          };
        },
      };
      const moveToArchive = {
        title: this.$t("common.delete"),
        icon: "delete",
        extras: {
          medium: true,
        },
        action: async (item) => {
          this.enterPassword.action = async () => {
            try {
              const { data } = await this.axios.delete(
                this.api.ACTIONS.CAPTAINS + "/" + item.id,
                {
                  data: {
                    password: this.enterPassword.password,
                    note: this.enterPassword.note,
                  },
                }
              );
              window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captains.archived"), "green");
              this.$refs.approved &&
                this.$refs.approved.removeItemFromTable(item);
              this.$refs.unapproved &&
                this.$refs.unapproved.removeItemFromTable(item);
              this.$refs.incomplete &&
                this.$refs.incomplete.removeItemFromTable(item);
              this.$refs.archived &&
                this.$refs.archived.addItemToTable(
                  Object.assign(item, {
                    deleted_at: moment().format("YYYY-MM-DD HH:mm:ss"),
                  })
                );
            } catch (e) {
              window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
              throw e;
            }
          };
          this.enterPassword.show = true;
          this.enterPassword.hint = this.$t("drivers.captains.aboutToArchive", { firstName: item.first_name, lastName: item.last_name });
          this.enterPassword.needsNote = true;
          return {};
        },
      };
      const unArchive = {
        title: this.$t("drivers.captains.unarchive"),
        icon: "lock_open",
        extras: {
          color: "primary",
          large: true,
        },
        action: async (item) => {
          try {
            const { data } = await this.axios.delete(
              this.api.ACTIONS.CAPTAINS + "/" + item.id
            );
            window.getApp.$emit(
              "SHOW_TOAST",
              !!item.approved_at ? this.$t("drivers.captains.movedToApproved") : this.$t("drivers.captains.movedToUnapproved"),
              "green"
            );
            this.$refs.archived.removeItemFromTable(item);
            item = data.data;
            if (!!item.approved_at)
              this.$refs.approved && this.$refs.approved.addItemToTable(item);
            else
              this.$refs.unapproved &&
                this.$refs.unapproved.addItemToTable(item);
          } catch (e) {
            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
            return {};
          }
        },
      };
      const goToProfile = {
        title: this.$t("drivers.captains.goToProfile"),
        icon: "info",
        extras: {
          color: "secondary",
          large: true,
        },
        action: async (item) =>
          this.$router.push({
            name: "CaptainProfile",
            params: item,
          }),
      };
      const blacklist = {
        title: this.$t("drivers.captains.blacklist"),
        icon: "block",
        extras: {
          color: "red",
          large: true,
        },
        action: (item) => {
          this.enterPassword.action = async () => {
            try {
              const { data } = await this.axios.post(
                this.api.ACTIONS.CAPTAINS + "/" + item.id + "/blacklist",
                {
                  password: this.enterPassword.password,
                  note: this.enterPassword.note,
                }
              );
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("drivers.captains.movedToBlacklisted"),
                "green"
              );
              this.$refs.approved &&
                this.$refs.approved.removeItemFromTable(item);
              this.$refs.unapproved &&
                this.$refs.unapproved.removeItemFromTable(item);
              this.$refs.blacklisted &&
                this.$refs.blacklisted.addItemToTable(item);
              return {};
            } catch (e) {
              console.log(e);
              window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
              return {};
            }
          };
          this.enterPassword.show = true;
          this.enterPassword.hint = this.$t("drivers.captains.aboutToBlacklist", { firstName: item.first_name, lastName: item.last_name });
          this.enterPassword.needsNote = true;

          return {};
        },
      };
      const unBlacklist = {
        title: this.$t("drivers.captains.unblacklist"),
        icon: "block",
        extras: {
          color: "green",
          large: true,
        },
        action: async (item) => {
          this.enterPassword.action = async () => {
            try {
              const { data } = await this.axios.post(
                this.api.ACTIONS.CAPTAINS + "/" + item.id + "/un_blacklist",
                { password: this.enterPassword.password }
              );
              window.getApp.$emit(
                "SHOW_TOAST",
                !!item.approved_at ? this.$t("drivers.captains.movedToApproved") : this.$t("drivers.captains.movedToUnapproved"),
                "green"
              );
              this.$refs.blacklisted.removeItemFromTable(item);

              if (!!item.approved_at)
                this.$refs.approved && this.$refs.approved.addItemToTable(item);
              else
                this.$refs.unapproved &&
                  this.$refs.unapproved.addItemToTable(item);
              return {};
            } catch (e) {
              window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
              return {};
            }
          };
          this.enterPassword.hint = this.$t("drivers.captains.aboutToUnblacklist", { firstName: item.first_name, lastName: item.last_name });

          this.enterPassword.show = true;
          this.enterPassword.needsNote = false;
        },
      };
      switch (state) {
        case "lost-incomplete":
          return {};
        case "unapproved":
          return { goToProfile, moveToApproved, moveToArchive };
        case "approved":
          if (this.hasPermission("BLACKLIST_CAPTAIN"))
            return { goToProfile, moveToArchive, blacklist };
          else return { goToProfile, moveToArchive };
        case "incomplete":
          return { goToProfile, answered, didntAnswer, moveToArchive };
        case "blacklisted":
          return { goToProfile, unBlacklist };
        case "new_acq":
          return { answered, didntAnswer };
        default:
          return { goToProfile, Unarchive: unArchive };
      }
    },
  },
};
</script>

<style>
.deleted-captain td {
  color: red !important;
}
</style>
